import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@core/auth';
import { PopoverController } from '@ionic/angular';
import { environment } from 'src/environments/environment';
import { ProfileComponent } from '../../components/profile/profile.component';
import {
  ProfileAction,
  ProfileType,
} from '../../components/profile/profile.types';
import { UserService } from '@core/yalo/user/user.service';
import { User } from '@core/yalo/user';

@Component({
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss'],
})
export class UserMenuComponent implements OnInit {
  user!: User;
  constructor(
    private popoverController: PopoverController,
    private _router: Router,
    private userService: UserService,
    private _authService: AuthService
  ) {}

  private _businessActions: ProfileAction[] = [
    {
      icon: 'ri-links-line',
      title: 'Vincular empresa existen-te',
      action: () => this.vincularEmpresa(),
    },
    {
      icon: 'ri-guide-line',
      title: 'Onboarding',
      action: () => this.onboarding(),
    },
    {
      icon: 'ri-building-line',
      title: 'Crear nueva empresa',
      action: () => this.crearEmpresa(),
    },
  ];

  private _personalActions: ProfileAction[] = [
    // {
    //   icon: 'ri-eye-2-line',
    //   title: 'Ver Onboarding de nuevo',
    //   action: () => this.initOnBoarding(),
    // },
    {
      icon: 'ri-logout-circle-r-line',
      title: 'Cerrar sesión',
      action: () => this.signOut(),
    },
  ];

  ngOnInit(): void {
    this.userService.getUserOnce().subscribe((user) => {
      this.user = user;
    });
  }

  // Business profile
  async presentBusinessProfile(event: any) {
    const profileType: ProfileType = 'empresarial';
    const businessProfile = await this.popoverController.create({
      component: ProfileComponent,
      componentProps: {
        profileType,
        user: this.user,
        actions: this._businessActions,
      },
      cssClass: 'profile-popover',
      event,
      showBackdrop: false,
      backdropDismiss: true,
    });
    await businessProfile.present();
  }

  vincularEmpresa() {
    window.open(`${environment.URL_BACKOFFICE}vincular`, '_blank');
    this.popoverController.dismiss();
  }

  crearEmpresa() {
    this._router.navigate(['organizacion/crear']);
    this.popoverController.dismiss();
  }

  onboarding() {
    this._router.navigate(['dashboard/onboarding']);
    this.popoverController.dismiss();
  }

  // Personal profile
  async presentPersonalProfile(event: any) {
    const profileType: ProfileType = 'personal';
    const personalProfile = await this.popoverController.create({
      component: ProfileComponent,
      componentProps: {
        profileType,
        user: this.user,
        actions: this._personalActions,
      },
      cssClass: 'profile-popover',
      event,
      showBackdrop: false,
      backdropDismiss: true,
    });
    await personalProfile.present();
  }

  initOnBoarding(): void {
    console.log('Onboarding');
  }

  signOut(): void {
    this.popoverController.dismiss();
    this._authService.signOut();
    this._router.navigateByUrl('/sign-in');
  }
}
